import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import "./Styles/DoughnutChart.css"

ChartJS.register(ArcElement, Tooltip, Legend);

// Your original data
const originalData = {
    labels: ['Reliance', 'Adani', 'Merion Care', 'Ruzzet', 'Steller Bio', 'Eskos'],
    datasets: [
        {
            label: 'Emissions(in CO2e)',
            data: [7729, 15321, 5258, 4524, 3332, 3535],
            backgroundColor: [
                'rgb(84,75,141)',
                'rgb(124,149,234)',
                'rgb(255,196,0)',
                'rgb(59,184,94)',
                'rgb(181,79,105)',
                'rgb(233,148,177)',
            ],
            borderColor: [
                'rgb(84,75,141)',
                'rgb(124,149,234)',
                'rgb(255,196,0)',
                'rgb(59,184,94)',
                'rgb(181,79,105)',
                'rgb(233,148,177)',
            ],
            borderWidth: 1,
        },
    ],
};

// Function to calculate the percentage
const calculatePercentage = (data) => {
    const total = data.reduce((acc, value) => acc + value, 0);
    return data.map((value) => ((value / total) * 100).toFixed(2));
};

// Calculate percentages
const percentages = calculatePercentage(originalData.datasets[0].data);

// Modified data with percentages
const dataWithPercentages = {
    labels: originalData.labels,
    datasets: [
        {
            ...originalData.datasets[0],
            data: originalData.datasets[0].data,
            percentages: percentages,
        },
    ],
};

export function DoughnutChart() {
    return (
        <div className='doughnutchart-container'>
            <div>
                <div>
                    <p>Emission by Supplier</p>
                </div>
                <div className='doughnutchart-container-expand-section'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.38349 15.2661C7.38349 15.6716 7.05505 16 6.64954 16H0.733945C0.656881 16 0.581651 15.9872 0.510091 15.9651C0.489908 15.9578 0.469724 15.9505 0.449541 15.9413C0.429357 15.9339 0.411009 15.9248 0.394495 15.9156C0.372477 15.9046 0.352293 15.8936 0.33211 15.8789C0.311926 15.8661 0.291743 15.8514 0.27156 15.8349C0.19633 15.7743 0.135779 15.7009 0.0899079 15.6147C0.0788987 15.5982 0.0697245 15.5798 0.0642199 15.5596C0.0587153 15.5541 0.0550453 15.5468 0.0532105 15.5376C0.0440362 15.5174 0.0366969 15.4954 0.0311923 15.4752C0.0110088 15.4092 0 15.3394 0 15.2661V9.35046C0 8.94495 0.330275 8.61651 0.733945 8.61651C1.13945 8.61651 1.46789 8.94495 1.46789 9.35046V13.4954L5.66422 9.29725C5.95046 9.01101 6.41651 9.01101 6.70275 9.29725C6.98899 9.58348 6.98899 10.0477 6.70275 10.3358L2.50642 14.5321H6.64954C7.05505 14.5321 7.38349 14.8605 7.38349 15.2661ZM16 0.733945V6.64954C16 7.05505 15.6716 7.38349 15.2661 7.38349C14.8605 7.38349 14.5321 7.05505 14.5321 6.64954V2.50642L10.3358 6.70275C10.1927 6.84587 10.0037 6.91743 9.81651 6.91743C9.62936 6.91743 9.44037 6.84587 9.29725 6.70275C9.01101 6.41651 9.01101 5.95046 9.29725 5.66422L13.4936 1.46789H9.35046C8.94495 1.46789 8.61651 1.13945 8.61651 0.733945C8.61651 0.32844 8.94495 0 9.35046 0H15.2661C15.3174 0 15.367 0.00550422 15.4128 0.0146785C15.4367 0.0201831 15.4605 0.0256881 15.4844 0.0330276C15.5064 0.040367 15.5284 0.0477064 15.5505 0.0587155C15.7266 0.13211 15.8679 0.273394 15.9413 0.449541C15.9523 0.471559 15.9596 0.493577 15.967 0.515596C15.9743 0.539449 15.9798 0.563302 15.9853 0.587155C15.9945 0.633027 16 0.682569 16 0.733945Z" fill="white" />
                        <path d="M7.38349 15.2661C7.38349 15.6716 7.05505 16 6.64954 16H0.733945C0.656881 16 0.581651 15.9872 0.510091 15.9651C0.489908 15.9578 0.469724 15.9505 0.449541 15.9413C0.429357 15.9339 0.411009 15.9248 0.394495 15.9156C0.372477 15.9046 0.352293 15.8936 0.33211 15.8789C0.311926 15.8661 0.291743 15.8514 0.27156 15.8349C0.19633 15.7743 0.135779 15.7009 0.0899079 15.6147C0.0788987 15.5982 0.0697245 15.5798 0.0642199 15.5596C0.0587153 15.5541 0.0550453 15.5468 0.0532105 15.5376C0.0440362 15.5174 0.0366969 15.4954 0.0311923 15.4752C0.0110088 15.4092 0 15.3394 0 15.2661V9.35046C0 8.94495 0.330275 8.61651 0.733945 8.61651C1.13945 8.61651 1.46789 8.94495 1.46789 9.35046V13.4954L5.66422 9.29725C5.95046 9.01101 6.41651 9.01101 6.70275 9.29725C6.98899 9.58348 6.98899 10.0477 6.70275 10.3358L2.50642 14.5321H6.64954C7.05505 14.5321 7.38349 14.8605 7.38349 15.2661ZM16 0.733945V6.64954C16 7.05505 15.6716 7.38349 15.2661 7.38349C14.8605 7.38349 14.5321 7.05505 14.5321 6.64954V2.50642L10.3358 6.70275C10.1927 6.84587 10.0037 6.91743 9.81651 6.91743C9.62936 6.91743 9.44037 6.84587 9.29725 6.70275C9.01101 6.41651 9.01101 5.95046 9.29725 5.66422L13.4936 1.46789H9.35046C8.94495 1.46789 8.61651 1.13945 8.61651 0.733945C8.61651 0.32844 8.94495 0 9.35046 0H15.2661C15.3174 0 15.367 0.00550422 15.4128 0.0146785C15.4367 0.0201831 15.4605 0.0256881 15.4844 0.0330276C15.5064 0.040367 15.5284 0.0477064 15.5505 0.0587155C15.7266 0.13211 15.8679 0.273394 15.9413 0.449541C15.9523 0.471559 15.9596 0.493577 15.967 0.515596C15.9743 0.539449 15.9798 0.563302 15.9853 0.587155C15.9945 0.633027 16 0.682569 16 0.733945Z" fill="black" fill-opacity="0.84" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4" fill="none">
                        <path d="M2 0C0.9 0 0 0.899976 0 1.99995C0 3.09992 0.9 3.9999 2 3.9999C3.1 3.9999 4 3.09992 4 1.99995C4 0.899976 3.1 0 2 0ZM14 0C12.9 0 12 0.899976 12 1.99995C12 3.09992 12.9 3.9999 14 3.9999C15.1 3.9999 16 3.09992 16 1.99995C16 0.899976 15.1 0 14 0ZM8 0C6.9 0 6 0.899976 6 1.99995C6 3.09992 6.9 3.9999 8 3.9999C9.1 3.9999 10 3.09992 10 1.99995C10 0.899976 9.1 0 8 0Z" fill="white" />
                        <path d="M2 0C0.9 0 0 0.899976 0 1.99995C0 3.09992 0.9 3.9999 2 3.9999C3.1 3.9999 4 3.09992 4 1.99995C4 0.899976 3.1 0 2 0ZM14 0C12.9 0 12 0.899976 12 1.99995C12 3.09992 12.9 3.9999 14 3.9999C15.1 3.9999 16 3.09992 16 1.99995C16 0.899976 15.1 0 14 0ZM8 0C6.9 0 6 0.899976 6 1.99995C6 3.09992 6.9 3.9999 8 3.9999C9.1 3.9999 10 3.09992 10 1.99995C10 0.899976 9.1 0 8 0Z" fill="black" fill-opacity="0.84" />
                    </svg>
                </div>
            </div>
            <Doughnut
                // style={{ width: "100px", height: "100px" }}
                data={dataWithPercentages}
                options={{
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom',
                        },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const label = context.label || '';
                                    const value = context.parsed;
                                    const percentage = percentages[context.dataIndex];
                                    return `${label}: ${value} (${percentage}%)`;
                                },
                            },
                        },
                    },
                }}
            />
        </div>
    );
}
